import { ApiService } from "../../../config/apiServices";
import {
  COE_ADMIN_REGISTRATIONS,
  COE_SPORTS_DISCIPLINES,
  COE_TRAINING_CENTRES,
  COE_DISTRICTS_BY_STATE,
} from "../../../config/adminUrlConfig";

export const getSportsDisciplines = () => {
  return ApiService.get(COE_SPORTS_DISCIPLINES);
};

export const getTrainingCentres = (disciplineId) => {
  const params = {};
  if (disciplineId) params.coe_sports_discipline_id = disciplineId;
  return ApiService.get(COE_TRAINING_CENTRES, { params });
};

export const getDistricts = (stateId = 4025) => {
  return ApiService.get(COE_DISTRICTS_BY_STATE(stateId));
};

export const getRegistrations = ({
  search = "",
  discipline = "",
  preferred_centre = "",
  district_id = "",
  age = "",
  page = 1,
  per_page = 10,
} = {}) => {
  const params = { page, per_page };
  if (search && search.trim() !== "") params.search = search.trim();
  if (discipline) params.discipline = discipline;
  if (preferred_centre) params.preferred_centre = preferred_centre;
  if (district_id) params.district_id = district_id;
  if (age) params.age = age;

  return ApiService.get(COE_ADMIN_REGISTRATIONS, { params });
};

export const getRegistrationById = (id) => {
  return ApiService.get(`${COE_ADMIN_REGISTRATIONS}/${id}`);
};

const coeRegistrationService = {
  getSportsDisciplines,
  getTrainingCentres,
  getDistricts,
  getRegistrations,
  getRegistrationById,
};

export default coeRegistrationService;
